import React, { useEffect, useMemo, useState } from 'react';
import './BalloonCelebration.css';

const COLORS = ['#fb6635', '#fbbf24', '#241C4F', '#ec4899', '#8b5cf6', '#14b8a6', '#ef4444'];
const BALLOON_COUNT = 24;
const BURST_ANGLES = [0, 45, 90, 135, 180, 225, 270, 315];

const random = (min, max) => min + Math.random() * (max - min);

function Balloon({ color, size }) {
  const height = size * 1.25;
  return (
    <svg
      className="balloon__body"
      width={size}
      height={height + 60}
      viewBox="0 0 40 110"
      aria-hidden="true"
    >
      <ellipse cx="20" cy="25" rx="18" ry="23" fill={color} />
      {/* Shine */}
      <ellipse cx="13" cy="16" rx="4" ry="7" fill="#fff" opacity="0.35" />
      {/* Knot */}
      <path d="M17 47 L23 47 L20 52 Z" fill={color} />
      {/* String */}
      <path
        d="M20 52 C 14 64, 26 76, 20 88 S 14 104, 20 110"
        fill="none"
        stroke="#94a3b8"
        strokeWidth="1"
      />
    </svg>
  );
}

// One-shot celebration: a wave of balloons floats up across the whole page and
// pops near the top, then the overlay unmounts itself. Purely decorative —
// never blocks clicks, and is hidden for users who prefer reduced motion.
export default function BalloonCelebration() {
  const balloons = useMemo(
    () =>
      Array.from({ length: BALLOON_COUNT }, (_, i) => ({
        id: i,
        color: COLORS[i % COLORS.length],
        left: random(2, 94),
        size: random(38, 66),
        delay: random(0, 2.8),
        duration: random(4.8, 6.8),
        // Pop somewhere in the top ~45% of the screen.
        popAt: random(6, 45),
      })),
    []
  );

  const [visible, setVisible] = useState(true);
  useEffect(() => {
    const longest = Math.max(...balloons.map((b) => b.delay + b.duration));
    const timer = setTimeout(() => setVisible(false), (longest + 0.5) * 1000);
    return () => clearTimeout(timer);
  }, [balloons]);

  if (!visible) return null;

  return (
    <div className="balloon-celebration" aria-hidden="true">
      {balloons.map((b) => (
        <div
          key={b.id}
          className="balloon"
          style={{
            left: `${b.left}%`,
            '--delay': `${b.delay}s`,
            '--duration': `${b.duration}s`,
            '--rise': `calc(-100vh + ${b.popAt}vh)`,
            '--color': b.color,
          }}
        >
          <div className="balloon__sway" style={{ animationDelay: `-${b.delay}s` }}>
            <Balloon color={b.color} size={b.size} />
            <div className="balloon__burst">
              {BURST_ANGLES.map((angle) => (
                <span key={angle} style={{ '--angle': `${angle}deg` }} />
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
